module.exports = __webpack_public_path__ + "media/dashboard/assets/bitespeed-logo-e574e1ad90824e7c55d7ae5849c4f40a.svg";